import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { IconTemplate } from "./IconTemplate";
import { useSDK } from "../shared/useSDK";
import {
  Breadcrumb,
  BreadcrumbAligner,
  BreadcrumbLink,
} from "./lib/Breadcrumb";

const listLink = {
  to: "/templates",
  text: "Templates",
  icon: <IconTemplate />,
};

export function BreadcrumbTemplate() {
  const params = useParams<{ uuid?: string }>();
  return (
    <BreadcrumbAligner>
      <Breadcrumb>
        <BreadcrumbLink to={listLink.to}>
          {listLink.icon}
          <span>{listLink.text}</span>
        </BreadcrumbLink>
        {params.uuid ? <BreadcrumbItem /> : null}
      </Breadcrumb>
    </BreadcrumbAligner>
  );
}

function BreadcrumbItem() {
  const params = useParams<{ uuid: string }>();
  const { sdk } = useSDK();
  const result = useQuery(["template", params.uuid], (key, uuid: string) =>
    sdk.getTemplate({ templateUuid: uuid })
  );
  const to = `/templates/${params.uuid}`;
  const fallbackText = "Template";
  if (result.status === "loading") {
    return null;
  }
  if (result.status === "error" || result.data === undefined) {
    return <BreadcrumbLink to={to}>{fallbackText}</BreadcrumbLink>;
  }
  return <BreadcrumbLink to={to}>{result.data.data.name}</BreadcrumbLink>;
}
